import { createSlice } from '@reduxjs/toolkit';
// eslint-disable-next-line import/no-cycle
import { RootState } from '..';
import { themeConfig } from '../../configs/theme.config';

interface MobileMenuInterfase {
  isMobileMenuDrawerClose: boolean;
  isMobileNotificationClose: boolean;
  isMobileProfileClose: boolean;
  isMobileHomeClose: boolean;
}

interface InitialStateInterfase {
  currentRouteKey: string;
  isMenuOpen: boolean;
  isAdmin: boolean;
  isNoticeOpen: boolean;
  language: string;
  mobileMenu: MobileMenuInterfase;
  popupShown?: boolean;
  loaderShown?: boolean;
  adminSubMenu?: string;
  adminImportantContact?: string;
  showSearchNav?: boolean;
  showNav?: boolean;
  isNotificationExpanded?: boolean;
  openVideoDialog?: boolean;
  isBrowserTabOpen?: boolean;
  adminFileSelect?: {
    selectedCategory?: string | null;
    selectedSubCategory?: string | null;
  };
  chatbotModalOpen?: boolean;
  profileModalOpen?: boolean;
  myProfileModalOpen?: boolean;
  chatbotTextMessageDisabled?: boolean;
  chatbotQuesId?: number;
  isSearchButton?: boolean;
  chatbotStart?: boolean;
  floatButtonCount?: number;
  footerApiCall?: boolean;
  taxInvestmentView?: boolean;
  fiscalYear?: string;
  // recentSearch?: any;
}

export const initialState: InitialStateInterfase = {
  currentRouteKey: '',
  isMenuOpen: false,
  isNoticeOpen: true,
  mobileMenu: {
    isMobileMenuDrawerClose: false,
    isMobileNotificationClose: false,
    isMobileProfileClose: false,
    isMobileHomeClose: false,
  },
  isAdmin: false,
  popupShown: true,
  loaderShown: true,
  language: themeConfig.language,
  adminSubMenu: '',
  adminImportantContact: undefined,
  showSearchNav: false,
  showNav: true,
  isNotificationExpanded: false,
  openVideoDialog: false,
  isBrowserTabOpen: true,
  adminFileSelect: {
    selectedCategory: null,
    selectedSubCategory: null,
  },
  chatbotModalOpen: false,
  profileModalOpen: false,
  myProfileModalOpen: false,
  chatbotTextMessageDisabled: true,
  chatbotQuesId: 0,
  isSearchButton: false,
  chatbotStart: false,
  floatButtonCount: 1,
  footerApiCall: true,
  taxInvestmentView: false,
  fiscalYear: '',
  // recentSearch: [],
};

export const commonSlice = createSlice({
  name: 'base/common',
  initialState,
  reducers: {
    setCurrentRouteKey: (state, action) => {
      const { open, id } = action.payload;
      state.currentRouteKey = id;
      state.isMenuOpen = open;
    },
    setMobileMenuDrawerClose: (state, action) => {
      const { menuKey, isDrawerOpen } = action.payload;

      // eslint-disable-next-line no-restricted-syntax
      for (const key in state.mobileMenu) {
        if (key === menuKey) {
          state.mobileMenu[key as keyof MobileMenuInterfase] = isDrawerOpen;
        } else {
          state.mobileMenu[key as keyof MobileMenuInterfase] = false;
        }
      }
    },

    setAdmin: (state, action) => {
      state.isAdmin = action.payload;
    },
    updateNoticeStatus: (state, action) => {
      state.isNoticeOpen = action.payload;
    },
    changeLanguage: (state, action) => {
      state.language = action.payload;
    },
    setPopupShow: (state, action) => {
      state.popupShown = action.payload;
    },
    setLoaderShow: (state, action) => {
      state.loaderShown = action.payload;
    },
    setAdminSubMenu: (state, action) => {
      state.adminSubMenu = action.payload;
    },
    setAdminImportantContact: (state, action) => {
      state.adminImportantContact = action.payload;
    },
    setShowSearchNav: (state, action) => {
      state.showSearchNav = action.payload;
    },
    setShowNav: (state, action) => {
      state.showNav = action.payload;
    },
    setNotificationExpanded: (state, action) => {
      state.isNotificationExpanded = action.payload;
    },

    setOpenVideoDialog: (state, action) => {
      state.openVideoDialog = action.payload;
    },

    setIsBrowserTabOpen: (state, action) => {
      state.isBrowserTabOpen = action.payload;
    },

    setAdminFileSelect: (state, action) => {
      const { type, value } = action.payload;
      if (type === 'category') state.adminFileSelect!.selectedCategory = value;
      if (type === 'subcategory')
        state.adminFileSelect!.selectedSubCategory = value;
    },
    setChatbotModalOpen(state, action) {
      state.chatbotModalOpen = action.payload;
    },
    setProfileModalOpen(state, action) {
      state.profileModalOpen = action.payload;
    },
    setMyProfileModal(state, action) {
      state.myProfileModalOpen = action.payload;
    },
    setChatbotTextMessageDisabled(state, action) {
      state.chatbotTextMessageDisabled = action.payload;
    },
    setChatbotQuesId(state, action) {
      state.chatbotQuesId = action.payload;
    },
    setIsSearchButton(state, action) {
      state.isSearchButton = action.payload;
    },
    setChatbotStart(state, action) {
      state.chatbotStart = action.payload;
    },
    setFloatButtonCount(state, action) {
      state.floatButtonCount = action.payload;
    },
    setFooterApiCall(state, action) {
      state.footerApiCall = action.payload;
    },
    setTaxInvestmentView(state, action) {
      state.taxInvestmentView = action.payload;
    },
    setFiscalYearSelect(state, action) {
      state.fiscalYear = action.payload;
    },
  },
});

export const {
  setCurrentRouteKey,
  setMobileMenuDrawerClose,
  setAdmin,
  updateNoticeStatus,
  changeLanguage,
  setPopupShow,
  setLoaderShow,
  setAdminSubMenu,
  setAdminImportantContact,
  setShowSearchNav,
  setShowNav,
  setAdminFileSelect,
  setNotificationExpanded,
  setOpenVideoDialog,
  setIsBrowserTabOpen,
  setChatbotModalOpen,
  setProfileModalOpen,
  setMyProfileModal,
  setChatbotTextMessageDisabled,
  setChatbotQuesId,
  setIsSearchButton,
  setChatbotStart,
  setFloatButtonCount,
  setFooterApiCall,
  setTaxInvestmentView,
  setFiscalYearSelect,
  // setRecentSearch,
} = commonSlice.actions;

export const commonState = (state: RootState) => state.base.common;

export default commonSlice.reducer;
